<form *ngIf="!submitted" [formGroup]="form" class="modal-main my-modal">
    <div class="modal-head my-modal__header">
        <h1>Recharge Business</h1>
    </div>
    <div class="my-modal__flex">
        <div class="my-modal__flex_basis">
            <h3>User Name:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.firstName }} {{ user?.lastName }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>CNIC:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.cnic }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Current Blance:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ user?.balance }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Deduction Amount:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="number" formControlName="amount" class="form-control" name="" id="amount">
            <small *ngIf="!form.valid">Please enter valid amount.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>GST:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="number" formControlName="gst" class="form-control" name="" id="gst">
            <small *ngIf="!form.valid">Please enter valid amount.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>WHT:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="number" formControlName="wht" class="form-control" name="" id="wht">
            <small *ngIf="!form.valid">Please enter valid amount.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Total:</h3>
        </div>
        <div class="my-modal__flex_basis">
            <p>{{ form.value.amount + form.value.gst + form.value.wht }}</p>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Deduction Type:</h3>
        </div>
        <div class="my-modal__flex_basis form-group" style="width: 170px;">
            <app-form-field-select
                            [control]="form.controls.adjustmentTypeId" formControlName="adjustmentTypeId"
                            [items]="adjustmentTypes">
                        </app-form-field-select>
        </div>
        <div class="my-modal__button">
            <app-button (click)="submit()" [disabled]="!form.valid">Save</app-button>
        </div>
    </div>
</form>

<form *ngIf="submitted && success" [formGroup]="form" class="my-modal">
    <div class="modal-head my-modal__header">
        <h1>Deduction</h1>
    </div>
    <div class="my-modal__icon">
        <img src="assets/images/popup.png">
    </div>
    <div class="modalbody my-modal__text">
        <p>Decuction of PKR {{ form.value.amount + form.value.gst + form.value.wht }} was successful.</p>
    </div>
    <div class="my-modal__button">
        <app-button (click)="close()">OK</app-button>
    </div>
</form>